export default __webpack_public_path__ + "images/0xcda86a272531e8640cd7f1a92c01839911b90bb0.png";